import axios from 'axios'
import LoginService from '@services/login-service.js'
import { getSavedState, saveState } from '@utils/auth.js'
import { FullAccess } from '@/constants/role.js'

export const state = {
    boAuthToken: getSavedState('auth.boAuthToken'),
    user: getSavedState('auth.user'),
    initTime: getSavedState('auth.initTime'),
    tokenExpiresAt: getSavedState('auth.tokenExpiresAt'),
}

export const mutations = {
    SET_CURRENT_USER(state, { boAuthToken, user, tokenExpiresAt }) {
        state.boAuthToken = boAuthToken
        state.user = user
        state.initTime = new Date().getTime()
        state.tokenExpiresAt = tokenExpiresAt

        saveState('auth.boAuthToken', `${boAuthToken}`)
        saveState('auth.user', user)
        saveState('auth.initTime', state.initTime)
        saveState('auth.tokenExpiresAt', tokenExpiresAt)

        setDefaultAuthHeaders(state)
    },
    SET_INIT_TIME(state, initTime) {
        saveState('auth.initTime', initTime)

        state.initTime = initTime
    },
}

export const getters = {
    loggedIn(state) {
        return !!state.boAuthToken
    },
    authToken(state) {
        return state.boAuthToken
    },
    tokenExpiresAt(state) {
        return state.tokenExpiresAt
    },
    initTime(state) {
        return state.initTime
    },
    allowedStores(state) {
        return state.user.allowedStores
    },
    merchantId(state) {
        return state.user.merchantId
    },
    userPermissions(state) {
        return state.user.permissions.reduce(
            (acc, permission) => ({
                ...acc,
                [permission]: true,
            }),
            {}
        )
    },
    isFullAccess(state, getters) {
        return getters.userPermissions[FullAccess]
    },
    StoresActOnBehalfMerchant(state, getters) {
        return (
            getters.isFullAccess ||
            getters.userPermissions['StoresActOnBehalfMerchant']
        )
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    init({ state, getters }) {
        if (getters.loggedIn) {
            setDefaultAuthHeaders(state)
        }
    },

    // Logs in the current user.
    async logIn({ commit }, data) {
        // turn on if validation needed
        const resp = await LoginService.boLogin(data)

        if (isLoginValidResp(resp)) {
            commit('SET_CURRENT_USER', resp)
        }

        return resp
    },

    // Logs out the current user.
    logOut({ commit }) {
        const boAuthToken = null
        const initTime = null
        const user = null
        const tokenExpiresAt = null

        commit('SET_INIT_TIME', initTime)
        commit('SET_CURRENT_USER', {
            boAuthToken,
            user,
        })

        saveState('auth.boAuthToken', boAuthToken)
        saveState('auth.user', user)
        saveState('auth.initTime', initTime)
        saveState('auth.tokenExpiresAt', tokenExpiresAt)
    },
}

function setDefaultAuthHeaders(state) {
    axios.defaults.headers.common.Authorization = state.boAuthToken
        ? `Bearer ${state.boAuthToken}`
        : ''
}

function isLoginValidResp(resp) {
    return resp.boAuthToken
}
